import { Sheet, SheetGroup } from '../../sheet';

export enum SheetGroupsCommandType {
  CreateGroup = 'CreateGroup',
  DeleteGroup = 'DeleteGroup',

  AddSheetToGroup = 'AddSheetToGroup',
  RemoveSheetFromGroup = 'RemoveSheetFromGroup',
  RenameGroup = 'RenameGroup',
}

export interface CreateSheetGroup {
  type: SheetGroupsCommandType.CreateGroup;
  group: SheetGroup;
}

export interface DeleteSheetGroup {
  type: SheetGroupsCommandType.DeleteGroup;
  groupId: string;
}

export interface AddSheetToGroup {
  type: SheetGroupsCommandType.AddSheetToGroup;
  groupId: string;
  sheetId: string
}

export interface RemoveSheetFromGroup {
  type: SheetGroupsCommandType.RemoveSheetFromGroup;
  groupId: string;
  sheetId: string;
}

export interface RenameSheetGroup {
  type: SheetGroupsCommandType.RenameGroup;
  groupId: string;
  name: string;
}

export type SheetGroupsCommand =
CreateSheetGroup
 | DeleteSheetGroup
  | AddSheetToGroup
  | RemoveSheetFromGroup
  | RenameSheetGroup;
// {
// base: EventBase.SheetGroups;
// } &
